import { LS_KEY_PREFIX_BY_NAMESPACE, AUDIENCE_TIMEOUT_MS } from "../constants";
import log from "../../../utils/logger/library";
import {
    isBrowser,
    isServer,
} from "../../../utils/environmentDetection/library";

/**
 * Get promise resolving to lotame audiences
 * or empty array if stats not initialized
 * @returns {Promise.<Array>}
 */
export async function getUserAudiences() {
    try {
        return (
            (await Promise.race([
                window?.CBC?.APP?.DMP?.LOTAME?.audiences,
                new Promise((resolve) => {
                    setTimeout(() => {
                        resolve([]);
                    }, AUDIENCE_TIMEOUT_MS);
                }),
            ])) || []
        );
    } catch (error) {
        log.error("Failed to get user audiences", error);
        return [];
    }
}

/**
 * @param {Array.<Object>} userAudiences audience segments from the DMP
 * @param {Array.<Number>} labels audience masks
 * @returns {Promise} The dispatch function
 */
export function filterAudiences(userAudiences, labels) {
    try {
        const filter =
            isBrowser() && window.CBC?.APP?.DMP?.LOTAME?.filterAudiences;

        if (typeof filter !== "function") {
            return [];
        }
        return window.CBC.APP.DMP.LOTAME.filterAudiences(userAudiences, labels);
    } catch (error) {
        log.error("Failed to get filter audiences function", error);
        return [];
    }
}

export const deserializePreference = (lsKey) => {
    if (isServer() || !window.localStorage) {
        return undefined;
    }

    let serialized = window.localStorage.getItem(lsKey);
    if (serialized !== null) {
        return !!+serialized;
    } else {
        return undefined;
    }
};

/**
 * @param {string} namespace
 * @param {string} key
 * @param {boolean} value
 */
export const saveLocalPreference = (namespace, key, value) => {
    if (!namespace || !key || !window?.localStorage) {
        return;
    }

    let lsKeyPrefix = LS_KEY_PREFIX_BY_NAMESPACE[namespace];
    if (!lsKeyPrefix) {
        return;
    }
    window.localStorage.setItem(lsKeyPrefix + key.toUpperCase(), +value);
};
